import React from 'react';
import { useIntl } from 'react-intl';
import css from './MeetVivian.module.css';
import wellnessImg from '../../../assets/landing/wellness-img.png';
import wellnessShape from '../../../assets/landing/wellness-shape1.png';
import Icons from '../../../components/Icons/Icons';
import { Button } from '../../../components';

function MeetVivian({ onRedirectToPage }) {
  const intl = useIntl();
  const title = intl.formatMessage({ id: 'MeetVivian.title' });
  const description = intl.formatMessage({ id: 'MeetVivian.description' });

  return (
    <section className={css.section}>
      <span className={css.shape1}>
        <img src={wellnessShape} alt="" />
      </span>
      <div className={css.content}>
        <div className={css.leftColumn}>
          <div className={css.titleBlock}>
            <h2 className={css.title} dangerouslySetInnerHTML={{ __html: title }} />
          </div>

          <div className={css.textBlock}>
            <p className={css.subtitle}>{description}</p>

            <Button
              type="button"
              className={css.aiCoachBtn}
              onClick={() => onRedirectToPage('AIConsultPage')}
            >
              <Icons name="aiButtonStar" /> {intl.formatMessage({ id: 'MeetVivian.cta' })}
            </Button>
          </div>
        </div>

        <div className={css.illustrationWrap}>
          <img src={wellnessImg} alt="" />
        </div>
      </div>
    </section>
  );
}

export default MeetVivian;
